import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import { BlogsAxios } from "../../axios/blogs/blogs.axios";
import { AtiraThunk } from "../AtiraThunk";
import { revertAllReduxAction } from "../store-reset";
import { userActions } from "../user/user.slice";

interface BlogsReducer {
  blogs: any[];
}

const initialState = Object.freeze<BlogsReducer>({
  blogs: [],
});

const getBlogs = AtiraThunk<any[], void>("/blogs/", () =>
  BlogsAxios.getBlogs(),
);

const blogsSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {},
  extraReducers: ({ addCase, addMatcher }) => {
    addCase(getBlogs.fulfilled, (state, action) => {
      state.blogs = action.payload;
    });

    addMatcher(isAnyOf(userActions.logout, revertAllReduxAction), (state) => {
      return (state = initialState);
    });
  },
});

export const blogsActions = {
  getBlogs,
};

export default blogsSlice.reducer;
